<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>{{ typeClientText }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <!------------ bouton ----------------->
    <div class="btn">
      <!-- <div class="button-row">
        <button *ngIf="!disabled" [disabled]="buttonDisabled || disabled" (click)="retourListes()" mat-raised-button class="colorGreen">
          <mat-icon>format_list_bulleted</mat-icon>
          Liste des
          {{typeClientText.toLowerCase()}}</button>
      </div>           -->
      <div class="button-row">
        <button
          type="submit"
          *ngIf="!disabled && index == 0"
          [disabled]="buttonDisabled || disabled"
          (click)="enregistrer()"
          mat-raised-button
          class="colorGreen"
        >
          <mat-icon>save</mat-icon>
          Enregistrer
        </button>
      </div>
    </div>

    <mat-tab-group
      [(selectedIndex)]="index"
      (selectedTabChange)="tabChanged($event)"
      (animationDone)="animationDone()"
      (focusChange)="setOldIndex()"
    >
      <!------------  -------------------information ----------------->
      <mat-tab label="Informations">
        <br />
        <form #formIniformation="ngForm">
          <input type="submit" style="display: none" id="btnHiddeb" />
          <div *ngIf="clientIsLoadet" class="displayFlexInfo">
            <mat-card class="example-card cardInformation">
              <mat-card-content>
                <mat-form-field
                  appearance="outline"
                  class="width20 marginRight10"
                >
                  <mat-label>Code</mat-label>
                  <input
                    maxlength="100"
                    disabled="true"
                    matInput
                    name="Tiers_Code"
                    style="width: 100%"
                    #Tiers_Code="ngModel"
                    [(ngModel)]="data.Tiers_code"
                    placeholder="Code"
                    required
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="width80">
                  <mat-label>Raison sociale</mat-label>
                  <input
                    maxlength="100"
                    [disabled]="disabled"
                    matInput
                    name="Tiers_RS"
                    style="width: 100%"
                    #Tiers_RS="ngModel"
                    [(ngModel)]="data.Tiers_RS"
                    placeholder="Raison sociale"
                    required
                  />
                  <mat-hint align="end"
                    >{{ data.Tiers_RS.length }} / 100</mat-hint
                  >
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Nom public</mat-label>
                  <input
                    maxlength="100"
                    matInput
                    [disabled]="disabled"
                    name="Tiers_NomPublic"
                    style="width: 100%"
                    #Tiers_NomPublic="ngModel"
                    [(ngModel)]="data.Tiers_NomPublic"
                    placeholder="Nom public"
                  />
                  <mat-hint align="end"
                    >{{ data.Tiers_NomPublic.length }} / 100</mat-hint
                  >
                </mat-form-field>
                <div class="displayFlexInfo">
                  <div class="width50">
                    <!-- <mat-form-field     appearance="outline"    class=" width80">
                      <mat-label>Type</mat-label>
                      <mat-select name="Tiers_Type" #Tiers_Type="ngModel" [(ngModel)]="data.Tiers_Type"  (selectionChange)="onTiersTypeChange($event.value)"
                        placeholder="Type"  required>
                        <mat-option *ngFor="let typeClient of listeTypeClient" [value]="typeClient.DiverSys_Index.toString()">{{typeClient.DiverSys_Titre}}</mat-option>
                      </mat-select>
                    </mat-form-field> -->
                    <!-- <mat-form-field  matTooltip="Ex: 1234x" [matTooltipPosition]="'above'"  appearance="outline"    class="width80">
                      <mat-label>Code naf</mat-label>
                      <input matInput maxlength="5" minlength="5" (input)="validerCodeNaf($event)" [disabled]="disabled"
                        name="Tiers_NAF" [(ngModel)]="data.Tiers_NAF" placeholder="Code naf" required>
                        <mat-hint align="end">{{(data.Tiers_NAF.length)}} / 5</mat-hint>
                    </mat-form-field> -->
                    <!-- <mat-form-field matTooltip="Ex: 123456789 12345" [matTooltipPosition]="'above'"     appearance="outline"    class="width80">
                      <mat-label>Siret</mat-label>
                      <input matInput maxlength="15" (input)="removeTextFromNumber($event)" pattern="^[0-9]{9,9} [0-9]{5,5}$" [disabled]="disabled" name="Tiers_Siret" #Tiers_Siret="ngModel"
                        [(ngModel)]="data.Tiers_Siret" placeholder="Ex: 123456789 12345" required>
                        <mat-hint align="end">{{(data.Tiers_Siret.length)}} / 15</mat-hint>
                    </mat-form-field> -->

                    <mat-form-field
                      matTooltip="Ex: FR 12 123456789"
                      [matTooltipPosition]="'above'"
                      appearance="outline"
                      class="width80"
                    >
                      <mat-label>Numero TVA</mat-label>
                      <input
                        matInput
                        maxlength="15"
                        [disabled]="disabled"
                        pattern="^FR [0-9]{2,2} [0-9]{9,9}$"
                        name="Tiers_TVA"
                        [(ngModel)]="data.Tiers_TVA"
                        placeholder="EX: FR 12 123456789"
                      />
                      <mat-hint align="end"
                        >{{ data.Tiers_TVA.length }} / 15</mat-hint
                      >
                    </mat-form-field>
                  </div>
                  <div class="width50">
                    <img (click)="selectImage()" [src]="avatarSrc" />
                    <input
                      type="file"
                      style="display: none"
                      id="imageFile"
                      (change)="onChangeImagefile($event)"
                    />
                    <div
                      class="button-row"
                      style="text-align: center; margin-top: 5px"
                    >
                      <button
                        *ngIf="!disabled"
                        [disabled]="!exist || disabled"
                        (click)="selectImage()"
                        mat-raised-button
                        class="colorGreen"
                      >
                        Choisir une photo
                      </button>
                    </div>
                  </div>
                </div>
                <app-recherche
                  [disabled]="disabled"
                  [api]="generalService.api"
                  [numColonneToShow]="1"
                  [style]="{
                    width: 'calc(90% - 10px)',
                    'margin-right': '10px',
                    'margin-top': '10px'
                  }"
                  (ChampEnter)="blurChamp($event)"
                  recherche="TierType"
                  [param]="'1'"
                  name="Machine_Emp"
                  [(ngModel)]="selectedTiersFacturation"
                  placeholder="Entité facturation"
                >
                </app-recherche>
                <mat-icon
                  *ngIf="!disabled"
                  (click)="openFrmNewEntiterFacturation()"
                  class="colorGreen icon"
                  >add</mat-icon
                >
                <br />
                <!-- <mat-form-field appearance="outline">
                <mat-label>Type d'evennement</mat-label>
                <mat-select name="Tiers_Stat1" #Tiers_Stat1="ngModel" [(ngModel)]="data.Tiers_Stat1">
                  <mat-optgroup *ngFor="let typeEvennement of listeTypeEvennementGroupe" [label]="typeEvennement.text">
                    <mat-option *ngFor="let pokemon of typeEvennement.listeEvennement" [value]="pokemon.evennemtCode.toString()">
                      {{pokemon.text}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field> -->
              </mat-card-content>
            </mat-card>
            <mat-card class="example-card cardInformation">
              <mat-card-header class="heightTitre">
                <mat-card-title>Coordonnées</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Mail pro</mat-label>
                  <input
                    matInput
                    type="email"
                    [disabled]="disabled"
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    name="Tiers_MailPro"
                    #Tiers_MailPro="ngModel"
                    [(ngModel)]="data.Tiers_MailPro"
                    placeholder="Mail pro"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Mail personnel</mat-label>
                  <input
                    matInput
                    type="email"
                    [disabled]="disabled"
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    name="Tiers_MailPersonnel"
                    [(ngModel)]="data.Tiers_MailPersonnel"
                    placeholder="Mail personnel"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="marginRight10 width50"
                >
                  <mat-label>T&eacute;l&eacute;phone fixe</mat-label>
                  <input
                    matInput
                    [disabled]="disabled"
                    name="Tiers_Contact_Tel"
                    [(ngModel)]="data.Tiers_Contact_Tel"
                    placeholder="T&eacute;l&eacute;phone fixe"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline" class="width50">
                  <mat-label>Mobile</mat-label>
                  <input
                    matInput
                    (input)="removeTextFromNumber($event)"
                    [disabled]="disabled"
                    name="Tiers_Contact_Mobile"
                    [(ngModel)]="data.Tiers_Contact_Mobile"
                    placeholder="Mobile"
                  />
                  <!--mat-hint align="end">{{(data.Tiers_Contact_Mobile.length)}} / 9</mat-hint-->
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Site web</mat-label>
                  <input
                    matInput
                    [disabled]="disabled"
                    name="Tiers_Web"
                    [(ngModel)]="data.Tiers_Web"
                    placeholder="Site web"
                  />
                </mat-form-field>
              </mat-card-content>
            </mat-card>
            <mat-card class="example-card cardInformation">
              <mat-card-header class="heightTitre">
                <mat-card-title>Adresse</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div *ngIf="show">
                  <!-- <mat-form-field     appearance="outline"    >
                                <input matInput [disabled]="disabled" name="Tiers_Intercommunautaire"
                                  [(ngModel)]="data.Tiers_Intercommunautaire" placeholder="Intercommunautaire" >
                              </mat-form-field> -->
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Adresse</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Tiers_Adresse"
                      [(ngModel)]="data.Tiers_Adresse"
                      placeholder="Adresse"
                      ngx-google-places-autocomplete
                      #placesRef="ngx-places"
                      (onAddressChange)="handleAddressChange($event)"
                    />
                  </mat-form-field>
                  <!-- <mat-form-field     appearance="outline"    class="full-width">
                    <input matInput [disabled]="disabled" name="Tiers_Rue" #Tiers_Rue="ngModel"
                      [(ngModel)]="data.Tiers_Rue" placeholder="Rue">
                  </mat-form-field> -->
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Compl&eacute;ment</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Tiers_Complement"
                      [(ngModel)]="data.Tiers_Complement"
                      placeholder="Compl&eacute;ment"
                    />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    class="marginRight10 width50"
                  >
                    <mat-label>Ville</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Tiers_Ville"
                      #Tiers_Ville="ngModel"
                      (input)="removeNumberFromText($event)"
                      [(ngModel)]="data.Tiers_Ville"
                      placeholder="Ville"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Region</mat-label>
                    <input
                      matInput
                      [disabled]="disabled"
                      name="Tiers_Region"
                      #Tiers_Region="ngModel"
                      [(ngModel)]="data.Tiers_Region"
                      placeholder="Region"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="marginRight10 width50"
                  >
                    <mat-label>Pays</mat-label>
                    <input
                      [disabled]="disabled"
                      matInput
                      [matAutocomplete]="auto"
                      name="Tiers_Pays"
                      #Tiers_Pays="ngModel"
                      [(ngModel)]="data.Tiers_Pays"
                      placeholder="Pays"
                      (input)="onPaysChange($event)"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        [(ngModel)]="ps.libelle"
                        *ngFor="let ps of pays"
                      >
                        {{ ps.libelle }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="width50">
                    <mat-label>Code postal</mat-label>
                    <input
                      matInput
                      maxlength="20"
                      (input)="removeTextFromNumber($event)"
                      [disabled]="disabled"
                      name="Tiers_CP"
                      #Tiers_CP="ngModel"
                      [(ngModel)]="data.Tiers_CP"
                      placeholder="Code postal"
                    />
                    <mat-hint align="end"
                      >{{ data.Tiers_CP.length }} / 20</mat-hint
                    >
                  </mat-form-field>
                  <!-- <mat-form-field     appearance="outline"    class="width50">
                      <input matInput [disabled]="disabled"
                        (input)="removeNumberFromText(data.Tiers_Departement,'Tiers_Departement')"
                        name="Tiers_Departement" #Tiers_Departement="ngModel" [(ngModel)]="data.Tiers_Departement"
                        placeholder="D&eacute;partement">
                    </mat-form-field> -->
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </form>
      </mat-tab>
      <!-- -------------------------------------interlocuteurs--------------------------------- -->
      <mat-tab [disabled]="disabledInterlocuteur" label="Interlocuteurs">
        <div *ngIf="showTabInterlocuteur">
          <app-avt-listes
            #listeInterlocuteurComponen
            [showFilter]="false"
            [heightTable]="'400'"
            [dataSourceBrut]="datasourceInterlocuteur"
            [displayedColumnsBrut]="columnsInterlocuteur"
            [listBtn]="listBtnInterlocuteur"
            (btnTable)="clickBtnHeat($event)"
          ></app-avt-listes>
        </div>
      </mat-tab>

      <!-- -------------------------------------Échanges--------------------------------- -->
      <mat-tab [disabled]="disabledEchanges" label="Échanges">
        <div *ngIf="showTabEchange">
          <!-- <app-avt-listes #listeEchangesComponen [showFilter]="false" [heightTable]="'400'" [dataSourceBrut]="datasourceEchanges" [displayedColumnsBrut]="columnsEchanges" [listBtn]="listBtnEchanges" (btnTable)="clickBtnHeat($event)"></app-avt-listes> -->
          <br />
          <app-avt-liste-echange
            [disabled]="disabled"
            [code]="param_code"
            [heightTable]="200"
            [type]="'client'"
          ></app-avt-liste-echange>
        </div>
      </mat-tab>
      <!-- -------------------------------------Alertes--------------------------------- -->
      <mat-tab [disabled]="disabledEAlertes" label="Alertes">
        <div *ngIf="showTabAlert">
          <!-- <app-avt-listes #listeAlectComponen [showFilter]="false" [heightTable]="'400'" [dataSourceBrut]="datasourceAlerte" [displayedColumnsBrut]="columnsAlerte" [listBtn]="listBtnAlerte" (btnTable)="clickBtnHeat($event)"></app-avt-listes> -->
          <app-avt-liste-alert
            [disabled]="disabled"
            *ngIf="param_code"
            [code]="param_code"
            [type]="'client'"
          ></app-avt-liste-alert>
        </div>
      </mat-tab>
      <!---------------------------------------- facture --------------------------------------- -->
      <mat-tab [disabled]="disabledEAlertes" label="Factures">
        <mat-card>
          <app-avt-listes
            #listeFactureComponen
            [heightTable]="'400'"
            [dataSourceBrut]="[]"
            [displayedColumnsBrut]="columnsFacture"
          >
          </app-avt-listes>
        </mat-card>
      </mat-tab>
      <!---------------------------------------- Devis --------------------------------------- -->
      <mat-tab [disabled]="disabledEAlertes" label="Devis">
        <mat-card>
          <app-avt-listes
            #listeDevisComponen
            [heightTable]="'400'"
            [dataSourceBrut]="[]"
            [displayedColumnsBrut]="columnsDevis"
          >
          </app-avt-listes>
        </mat-card>
      </mat-tab>
      <!---------------------------------------- Action --------------------------------------- -->
      <mat-tab [disabled]="disabledEAlertes" label="Actions">
        <mat-card>
          <app-avt-listes
            #listeActionComponen
            [heightTable]="'400'"
            [dataSourceBrut]="[]"
            [displayedColumnsBrut]="columnsAction"
          >
          </app-avt-listes>
        </mat-card>
      </mat-tab>
      <!-- -------------------------------------Documents--------------------------------- -->
      <mat-tab [disabled]="disabledEDocuments" label="Documents">
        <div *ngIf="showDoc && clientIsLoadet">
          <app-show-tree-doc
            [param_code]="data.Tiers_code"
            [File_Type]="'client'"
            [typeTrs]="typeTrs"
          >
          </app-show-tree-doc>
        </div>
        <!-- <app-liste-facture [param_code]="param_code" [showToolbar]='false'></app-liste-facture>  -->
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
<input
  id="hiddenBtnForActualiserListe"
  (click)="doNotThink()"
  type="submit"
  style="display: none"
  value="aa"
/>
